export default dsf.component({
  name: "DsfProjectConfig",
  mixins: [$mixins.control],
  ctrlCaption: "项目配置",
  data() {
    return {
      data: [],
      activeIndex: "",
      defaultOpeneds: [],
      pageUrl: "",
    };
  },
  props: {
    height: {
      type: [Number, String],
      default: "100%",
    },
  },
  computed: {
    boxStyle() {
      return {
        height: dsf.isNumber(this.height) ? `${this.height}px` : this.height,
      };
    },
  },
  render(h) {
    let {boxStyle, activeIndex, defaultOpeneds, handleSelect, renderMenuNodes, data, pageUrl} = this;
    return (<div ref="container" class="ds-control ds-project-config" style={boxStyle}>
      <div class="dpc-l" style={boxStyle}>
        <dsf-virtual-scroll>
          <el-menu
            default-active={activeIndex}
            default-openeds={defaultOpeneds}
            on={{
              select: handleSelect
            }}>
            {renderMenuNodes(h, data)}
          </el-menu>
        </dsf-virtual-scroll>
      </div>
      <div class="dpc-r" style={boxStyle}>
        <iframe style={boxStyle} width="100%" src={pageUrl} frameborder="0" />
      </div>
    </div>);
  },
  created() {
    this.loadData();
  },
  methods: {
    renderMenuNodes(h, list) {
      return _.map(list, it => {
        if (it.type == '1') {
          return (<el-menu-item index={it.id}>{it.name}</el-menu-item>)
        }
        return (<el-submenu index={it.id}>
          <span slot="title">{it.name}</span>
          {this.renderMenuNodes(h, it.children)}
        </el-submenu>)
      });
    },
    handleSelect(index) {
      this.activeIndex = index;
      this.setPageUrl();
    },
    setDefaultIndex(data) {
      let stack = [...data];
      while (stack.length) {
        let target = stack.pop();
        let children = target.children;
        if (children && children.length) {
          let i = children.length;
          while (i) {
            i--;
            stack.push(children[i]);
          }
        }
        if (target.type == "1") {
          this.activeIndex = target.id;
          //清栈
          stack = []
        }
      }
    },
    setPageUrl(d) {
      const fn = (arr) => {
        let index = 0;
        while (index < arr.length) {
          const target = arr[index];
          if (target.id === this.activeIndex && target.type == "1") {
            let id = this.queryString.globalId
              ? this.queryString.globalId
              : target.id;
            let query = dsf.url.queryStringStringify(this.queryString);
            this.pageUrl = dsf.url.getWebPath(
              `~/page.html#/pc/${target.path}?id=${id}&${query}`
            );
            break;
          } else if (target.children && target.children.length) {
            fn(target.children);
          }
          index += 1;
        }
      };
      fn(d || this.data);
    },
    loadData() {
      this.$http.get("/setting/directory").then(({ data }) => {
        if (Array.isArray(data?.data) && data.data.length) {
          this.setDefaultIndex(data.data);
          this.setPageUrl(data.data);
          const arr = [];
          const fn = (d) => {
            d.forEach((it) => {
              if (it.type == "0") {
                arr.push(it.id);
                fn(it.children);
              }
            });
          };
          fn(data.data);
          this.defaultOpeneds = arr;
          this.data = data.data;
        }
      });
    },
  },
  watch: {
    height: {
      handler(v) {
        if (this.isDesign) {
          let height = v;
          if (!v) {
            height = "auto";
          }
          if (dsf.isNumber(height)) {
            height += "px";
          }
          this.$dispatch("design-height-change", height);
        }
      },
      immediate: true,
    },
  },
});
